<template>
  <v-dialog v-model="reportDialog" width="850">
    <!--Normal-->
    <template v-if="$vuetify.breakpoint.smAndUp">
      <v-card>
        <!-- <pre>{{articledata}}s</pre> -->
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <span class="display-1 text-uppercase font-weight-bold">{{$t('general.Report')}}</span>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            :title="$t('general.close')"
            class="ma-2"
            outlined
            icon
            large
            @click="closeDialog"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <p class="pr-5 text--primary title pt-5">
            {{$t('general.Report article')}}
            {{
              reportData.reportType == "article"
                ? "artikkel"
                : reportData.reportType == "comment"
                ? "kommentar"
                : "resetting..."
            }}:
            <span class="font-italic">{{ reportData.content }}</span>
          </p>
          <v-divider></v-divider>
          <v-divider></v-divider>
          <v-row>
            <v-spacer></v-spacer>
            <v-col md="6" class="ma-0 pa-0 pt-12">
              <v-select
                outlined
                :items="reasons"
                v-model="reportData.reason"
                :label="$t('general.Select reason of report')"
              ></v-select>
            </v-col>
            <v-spacer></v-spacer>
            <v-col md="12">
              <p class="text-center black--text mb-0 title">{{$t('general.More information')}}</p>
            </v-col>
            <v-col md="12 pt-0">
              <v-textarea
                outlined
                auto-grow
                v-model="reportData.moreDetails"
                rows="5"
                 :label="$t('general.Write more information here')"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="submitReport">{{$t('general.Report')}}</v-btn>
          <v-btn color="warning" @click="closeDialog">{{$t('general.close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </template>
    <!--Phone-->
    <template v-else>
      <v-card>
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <span class="display-1 text-uppercase font-weight-bold">{{$t('general.Report')}}</span>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            :title="$t('general.close')"
            class="ma-2"
            outlined
            icon
            large
            @click="closeDialog"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <p class="pr-5 text--primary title pt-5">
            {{$t('general.Report article')}}
            <span class="italic">{{ reportData.content }}</span>
          </p>
          <v-divider></v-divider>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="12" class="ma-0 pa-0 pt-12">
              <v-select
                outlined
                :items="reasons"
                v-model="reportData.reason"
                :label="$t('general.Select reason of report')"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <p class="text-center black--text mb-0 title">{{$t('general.More information')}}</p>
            </v-col>
            <v-col cols="12">
              <v-textarea
                outlined
                auto-grow
                rows="5"
                v-model="reportData.moreDetails"
                :label="$t('general.Write more information here')"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="submitReport">{{$t('general.Report')}}</v-btn>
          <v-btn color="warning" @click="closeDialog">{{$t('general.close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
// Import the i18n - This may need to be modified
import messages from "../modules/lang/export";
import { mapActions } from "vuex";

export default {
  // Communicate with i18n
  i18n: { messages },
  data() {
    return {
      // Define the dialog v-model that we are using
      reportDialog: false,
      // articledata: {}
      reasons: [this.$t("general.Duplicate"), this.$t("general.Harrasment"), this.$t("general.Breaking TOS")],
      reportData: {
        reason: "",
        moreDetails: "",
        reportedId: null,
        reportType: "",
        content: ""
      }
    };
  },
  watch: {
    reportDialog(newVal) {
      if (newVal === false) {
        this.reportData.reason = "";
        this.reportData.moreDetails = "";
        this.reportData.reportedId = null;
        this.reportData.reportType = "";
        this.reportData.content = "";
      }
    }
  },
  methods: {
    ...mapActions(["POST_REPORT"]),
    submitReport() {
      let _ReportObject = {
        Reason: this.reportData.reason,
        moreDetails: this.reportData.moreDetails,
        reportType: this.reportData.reportType
      };

      switch (this.reportData.reportType) {
        case "article":
          _ReportObject.Articles_id = this.reportData.reportedId;
          break;
        case "comment":
          _ReportObject.Article_Comments_id = this.reportData.reportedId;
          break;
        default:
          console.error("wrong data. ");
          alert("Sorry, an error occured. Your report was not saved.");
          this.reportDialog = false;
      }
      this.POST_REPORT(_ReportObject)
        .then(res => {
          alert("Your report is received");
          this.$emit("updatearticle");
          this.reportDialog = false;
        })
        .catch(err => {
          alert("Sorry, an error occured. Your report may not be saved.");
          this.reportDialog = false;
        });
    },
    // Opening the dialog through the ref
    openDialog(incomingData) {
      if (incomingData) {
        // this.reportData = {
        //   ...this.reportData,
        //   ...incomingData
        // };

        this.reportData = Object.assign({}, this.reportData, incomingData);
      }
      // this.articledata = articledata;
      this.reportDialog = true;
    },
    // Close the dialog
    closeDialog() {
      this.reportDialog = false;
    }

    // // Submit form
    // ReportArticle() {
    //   let reportForm = {
    //     reason = this.reason,
    //     moreDetails = this.moreDetails,
    //     articleId = this.articleId,
    //     reportedBy = this.reportedBy
    //   };

    //   this.REPORT_FORM(reportForm);
    //   this.closeAndCleanDialog();
    // },

    // ReportArticleTwo(){
    //   this.reportData;
    //   this.REPORT_FORM(reportData);
    //   this.closeAndCleanDialog();
    // }

    // In store.js
    //  REPORT_FORM({ commit }, data) {
    //     axios.post("URL", data).then(response => {
    //       //
    //     });
    //   },
  }
};
</script>
